var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import merge from 'lodash.merge';
import { useEffect, useRef, useState } from 'react';
import { Chart as ReactChart } from 'react-chartjs-2';
import { waterfallOptions } from './Waterfall.options';
import { customWaterfallPlugin } from './Waterfall.plugin';
/**
 * This component will combine the dataset provided to be compliant with floating bars and display as a waterfall chart.
 * We need to support changing chart types, but the data for waterfall differs from other ones.
 * Important: dataset's data has to have the same length in each element.. Background color is required as well for each dataset.
 * datasetReferenceIndex: this param refers to which will be the reference data in the dataset to be compared against.
 * summary: this param refers to adding an extra label for the summary with the indicated color and text.
 * What it does, is to compare datasets values with the same index. The difference will generate three outputs:
 * Minimum: will be the minimum of the floating bar in the Y axis.
 * Maximum: will be the maximum of the floating bar in the Y axis.
 * Color: the highest value will determine the color of the bar.
 * -----
 * Structure for floating bars:
 * labels: ['category1', 'category2']
 * datasets: [
 *    {
 *      data: [ [100, 200], [300, 400] ], // Here data is an array of array, where the first number is the minimum, the second the maximum.
 *      backgroundColor: ['color1', 'color2'] // Here backgroundColor is an array, matching colors with data by index.
 *    }
 * ]
 */
export function WaterfallChart(_a) {
    var options = _a.options, _b = _a.labels, labels = _b === void 0 ? [] : _b, _c = _a.datasets, datasets = _c === void 0 ? [] : _c, waterfallPluginProps = __rest(_a, ["options", "labels", "datasets"]);
    var mergedOptions = useRef({});
    var _d = useState(null), data = _d[0], setData = _d[1];
    useEffect(function () {
        var _a, _b, _c, _d;
        var formatOpts = ((_b = (_a = options === null || options === void 0 ? void 0 : options.scales) === null || _a === void 0 ? void 0 : _a.y) === null || _b === void 0 ? void 0 : _b.formatOpts) || ((_d = (_c = options === null || options === void 0 ? void 0 : options.scales) === null || _c === void 0 ? void 0 : _c.y) === null || _d === void 0 ? void 0 : _d.formatOpts);
        mergedOptions.current = merge({}, options, waterfallOptions(formatOpts), {
            plugins: { waterfall: waterfallPluginProps },
        });
        setData({
            labels: labels,
            datasets: datasets,
        });
    }, []);
    if (!data)
        return null;
    return (_jsx(ReactChart, { type: "bar", options: mergedOptions.current, data: data, plugins: [ChartDataLabels, __assign({}, customWaterfallPlugin)] }));
}
